import React, { Component } from 'react'
import { Flex } from 'reflexbox'
import styles from './styles.scss'
import CSSModules from 'helpers/CSSModulesUtil'
import Collapse from 'components/fulcrum/collapse/Collapse'
import { IconButton } from 'react-toolbox/lib/button'
import { 
  collapseSelector,
  collapsingSelector,
  stickySelector,
} from './selectors'

import { scrolledTop } from 'containers/Project/View/selectors'
import {
  collapseHeader,
  expandHeader,
  toggleHeader,
  setCollapsing,
  setSticky
} from './actions'

import { connect } from 'react-redux'
import cn from 'classnames'
import GpuSku from 'components/project/notebookGpuSku/index'
import T from 'i18n-react'
import { compose } from 'recompose'
import Restricted from './Restricted'
import RiskElement from 'components/form/risk/index'
import notifyHoc from 'containers/App/Notification/Notify'
import {
    toggleRestricted,
    toggleUiRestricted,
  } from 'containers/Form/Restricted/actions'

const Risk = notifyHoc(RiskElement)

const mapStateToProps = (state) => {
  return {
    collapse: collapseSelector(state),
    scrolledTop: scrolledTop(state),
    collapsing: collapsingSelector(state),
    sticky: stickySelector(state),
    restricted: state.uiState.project.restricted,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    collapseHeader: () => dispatch(collapseHeader()),
    expandHeader: () => dispatch(expandHeader()),
    toggleHeader: () => dispatch(toggleHeader()),
    setCollapsing: (collapsing) => dispatch(setCollapsing(collapsing)),
    onToggleRestricted: () => dispatch(toggleRestricted()),
    onToggleUiRestricted: () => dispatch(toggleUiRestricted()),
    setSticky: (sticky) => dispatch(setSticky(sticky))
  }
}

class Header extends Component {

  toggleCollapse = () => {
    const {
      toggleHeader
    } = this.props

    toggleHeader()
  }

  collapsingStart = () => {
    const { scrolledTop, setSticky } = this.props
    if (scrolledTop) setSticky(false)
  }

  collapsingEnd = () => {
    const { scrolledTop, setSticky } = this.props
    if (!scrolledTop) setSticky(true)
  }

  onChange = () => {
    this.props.onToggleRestricted()
    this.props.onToggleUiRestricted()
  }
  render() {

    const {
      review,
      update,
      collapse,
      sticky,
      id,
      sku,
      brand,
      partnerSiteName,
      segment,
      risk,
      restricted,
      gpuSku
    } = this.props

    const icon = collapse ? 'chevron_right' : 'expand_more'

    const updateStyle = update ? styles.editHeaderContainer : null
    const stickyStyle = sticky ? styles.headerContainerScroll : null
    const containerClasses = cn(styles.headerContainer, updateStyle, stickyStyle)

    return (
        <Flex className={containerClasses}>
          <Flex styleName='subHeader'>
            <IconButton styleName='moreInfoIcon' icon={icon} theme={styles} onClick={this.toggleCollapse}/>
            <h4 className={styles.title}>Project #{id}</h4>
            <Risk
                message={T.translate('pages.project.update.notification.risk')}
                isRisk={risk}
            />
          </Flex>
          <Collapse collapse={collapse} theme={styles.collapse} onAnimationStart={this.collapsingStart} onAnimationEnd={this.collapsingEnd} duration={0}>
            <div>{partnerSiteName}</div>
            <div>{sku} - {brand}</div>
            <GpuSku
                segment={segment}
                gpuSku={gpuSku}
                />
            {!review && <Restricted
                onChange={this.onChange}
                restricted={restricted}
                />}
          </Collapse>
        </Flex>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withStyles = CSSModules(styles)
const enhance = compose(
  withConnect,
  withStyles,
)

export default enhance(Header)
